import React, { useState, useCallback, useMemo, useEffect } from 'react'
import {
  Radio,
  Button,
  Form,
  Input,
  Popover,
  Upload,
  Message,
  Modal,
  Card
} from '@arco-design/web-react'
import { b2ValueUnit } from 'common/utils'
import {
  IconDelete,
  IconPlus,
  IconUpload,
  IconEye
} from '@arco-design/web-react/icon'
import ColorPicker, { useColorPicker } from 'react-best-gradient-color-picker'
import './SaasSeting.scss'
import { upload } from 'api/apis'
import { BosClient } from '@baiducloud/sdk'
import { updateSaasSetting } from 'api/apis'
import { saasDefaultSetting } from 'mocks/saasDefaultSetting'

const SaasSeting = ({ data, changeSetting }) => {
  const { setting } = data
  const style = setting?.GlobalConfiguration
  // 动态列表状态

  // const [scrollList, setScrollList] = useState(setting?.hellodata || [])
  // 表单验证状态

  const [validationErrors, setValidationErrors] = useState({})
  // 颜色状态定义

  const [backgroundColor, setBackgroundColor] = useState(
    style?.css?.['--creationplatform-background'] ||
      'linear-gradient(122deg, #4e3eff 2%, #ececff 83%)'
  ) // 文档创作台背景色

  const [borderColor, setBorderColor] = useState(
    style?.css?.['--yoo-theme-border-color'] || '#4838ff'
  ) // 边线颜色

  const [colorBg, setColorBg] = useState(
    style?.css?.['--yoo-theme-color'] || '#4838ff'
  ) // 默认主题色

  const [hoverColor, setHoverColor] = useState(
    style?.css?.['--yoo-theme-hover-bg'] || '#FFF7FF'
  ) // 按钮hover颜色

  const [lgColor, setLgColor] = useState(
    style?.css?.['--yoo-theme-lg'] ||
      'linear-gradient(270deg, #6040fc 15%, #e750e6 100%)'
  ) // 首页按钮文字颜色

  const [lgimageColor, setLgimageColor] = useState(
    style?.css?.['--yoo-theme-lgimage'] ||
      'linear-gradient(90deg, #FA52E3 0%, #4E3EFF 100%)'
  ) // 流程输入框发送按钮颜色

  const [tolgimageColor, setTolgimageColor] = useState(
    style?.css?.['--yoo-theme-tolgimage'] ||
      'linear-gradient(right, #fa52e3 25%, #4e3eff 50%, #2e91ff 75%, #ff5ef9 100% )'
  ) // 首页输入框发送按钮颜色

  // 上传文件状态
  const [homeColorLogo, setHomeColorLogo] = useState(style?.business_logo) // 首页彩色logo
  const [homeColorLogoFile, setHomeColorLogoFile] = useState(null) // 首页彩色logoFile - 初始化为null

  const [whiteLogo, setWhiteLogo] = useState(style?.white_logo) // 白色logo
  const [whiteLogoFile, setWhiteLogoFile] = useState(null) // 白色logoFile - 初始化为null

  const [homeBackgroundIcon, setHomeBackgroundIcon] = useState(
    style?.home_banner
  ) // 首页背景icon
  const [homeBackgroundIconFile, setHomeBackgroundIconFile] = useState(null) // 首页背景iconFile - 初始化为null

  // 首页文本状态
  const [homeTextLine1, setHomeTextLine1] = useState(
    style?.home_uptitle || '会说话'
  )
  const [homeTextLine2, setHomeTextLine2] = useState(
    style?.home_title || '就能写好PPT'
  )
  const [showLogo, setShowLogo] = useState(style?.show_logo === 'true') // 是否联名展示logo
  const [helloData, setHelloData] = useState(setting?.hellodata || [''])
  // 颜色选择器钩子关联
  useColorPicker(lgColor, setLgColor)
  useColorPicker(lgimageColor, setLgimageColor)
  useColorPicker(tolgimageColor, setTolgimageColor)
  useColorPicker(hoverColor, setHoverColor)
  useColorPicker(borderColor, setBorderColor)
  useColorPicker(colorBg, setColorBg)
  useColorPicker(backgroundColor, setBackgroundColor)

  useEffect(() => {
    if (setting?.hellodata) {
      setHelloData(setting.hellodata)
    }
    if (style?.home_banner) {
      setHomeBackgroundIcon(style.home_banner)
    }
    if (style?.white_logo) {
      setWhiteLogo(style.white_logo)
    }
    if (style?.business_logo) {
      setHomeColorLogo(style.business_logo)
      console.log(style.business_logo)
    }
    if (style?.show_logo) {
      setShowLogo(style.show_logo)
    }
    if (style?.home_uptitle) {
      setHomeTextLine1(style.home_uptitle)
    }
    if (style?.home_title) {
      setHomeTextLine2(style.home_title)
    }
    if (style?.css) {
      setBackgroundColor(style.css['--creationplatform-background'] || '')
      setBorderColor(style.css['--yoo-theme-border-color'] || '#4838ff')
      setColorBg(style.css['--yoo-theme-color'] || '#4838ff')
      setHoverColor(style.css['--yoo-theme-hover-bg'] || '#FFF7FF')
      setLgColor(style.css['--yoo-theme-lg'] || '')
      setLgimageColor(style.css['--yoo-theme-lgimage'] || '')
      setTolgimageColor(style.css['--yoo-theme-tolgimage'])
    }
  }, [style?.css, style, setting?.hellodata])

  // 颜色配置数组 - 统一管理所有颜色选项
  const colorConfig = useMemo(() => [
    {
      label: '--creationplatform-background',
      name: '文档创作台背景色',
      value: backgroundColor,
      onChange: setBackgroundColor
    },
    {
      label: '--yoo-theme-border-color',
      name: '边线颜色',
      value: borderColor,
      onChange: setBorderColor
    },
    {
      label: '--yoo-theme-color',
      name: '默认主题色',
      value: colorBg,
      onChange: setColorBg
    },
    {
      label: '--yoo-theme-hover-bg',
      name: '按钮hover颜色',
      value: hoverColor,
      onChange: setHoverColor
    },
    {
      label: '--yoo-theme-lg',
      name: '首页按钮文字颜色',
      value: lgColor,
      onChange: setLgColor
    },
    {
      label: '--yoo-theme-lgimage',
      name: '流程输入框发送按钮颜色',
      value: lgimageColor,
      onChange: setLgimageColor
    },
    {
      label: '--yoo-theme-tolgimage',
      name: '首页输入框发送按钮颜色',
      value: tolgimageColor,
      onChange: setTolgimageColor
    }
  ])

  // 创建一个辅助函数来生成文件对象
  const createFileObject = (fileInfo) => {
    // 创建一个模拟的文件对象，包含arco-design upload组件需要的字段
    return {
      uid: fileInfo.object_key || Date.now().toString(),
      name: fileInfo.file || 'uploaded_file',
      url: fileInfo.result_url || fileInfo,
      status: 'done',
      percent: 100,
      response: fileInfo
    }
  }

  const handleUpload = (option, setter, fileSetter) => {
    const client = new BosClient({})
    const file = option.file
    const param = {
      type: '',
      mime: option.file.type || 'application/octet-stream',
      size: option.file.size,
      file: option.file.name
    }
    upload(param).then((res) => {
      if (res.code === 200) {
        const bosConfig = {
          endpoint: res.data.end_point,
          credentials: {
            ak: res.data.accessKeyID,
            sk: res.data.secretAccessKey
          },
          sessionToken: res.data.sessionToken
        }
        client.config = bosConfig
        const bucket = res.data.buck_name

        const done = (response) => {
          // 成功回调处理
          setter(res.data.result_url)
          console.log(res.data.result_url)
          // 创建文件对象并设置到fileList状态中
          const fileObject = createFileObject(res.data)
          fileObject.originFile = file // 保留原始文件对象，确保预览始终可用
          fileSetter(fileObject)

          // Message.success(`${file.name} 上传成功`)
        }

        const fail = (fail) => {
          // 失败回调处理
          Message.error(`${file.name} 上传失败`)
          setter(null)
        }
        // 合并headers
        const requestHeaders = {
          ...res.data.headers
        }

        if (
          file.type.indexOf('image') > -1 &&
          !requestHeaders['Content-Type']
        ) {
          requestHeaders['Content-Type'] = file.type
        }

        client
          .putObjectFromBlob(bucket, res.data.object_key, file, requestHeaders)
          .then(done)
          .catch(fail)

        client.on('progress', function (evt) {
          if (evt.lengthComputable) {
            const percentageValue = parseInt(
              (evt.loaded / evt.total) * 100 + ''
            )
            // 进度处理
            console.log(`上传进度: ${percentageValue}%`)
          }
        })
      }
    })
  }
  const renderUploadList1 = (filesList, props) => (
    <div style={{ display: 'flex', marginTop: 12 }}>
      {filesList.map((file) => {
        const url = file.originFile
          ? URL.createObjectURL(file.originFile)
          : file.url
        return (
          <div
            style={{
              width: 120,
              height: 120,
              borderRadius: 10,
              position: 'relative'
            }}
            key={file.uid}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                opacity: 0,
                zIndex: 100,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = 1
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = 0
              }}
            >
              <div
                onClick={() => {
                  Modal.info({
                    title: '预览',
                    content: (
                      <img
                        src={url || file.url}
                        width="100%"
                        alt={file.name.split('.')[0]}
                      />
                    )
                  })
                }}
              >
                <IconEye style={{ fontSize: 12, color: '#fff' }} />
              </div>
              <div>
                <IconDelete
                  style={{ fontSize: 12, color: '#fff', marginLeft: 10 }}
                  onClick={() => {
                    props.onRemove(file)
                  }}
                />
              </div>
            </div>
            <img
              src={url}
              style={{ width: '100%', height: '100%', borderRadius: 10 }}
              alt={file.name.split('.')[0]}
            />
          </div>
        )
      })}
    </div>
  )
  const renderUploadList2 = (filesList, props) => (
    <div style={{ display: 'flex', marginTop: 12 }}>
      {filesList.map((file) => {
        const url = file.originFile
          ? URL.createObjectURL(file.originFile)
          : file.url
        return (
          <div
            style={{
              width: 150,
              height: 50,
              borderRadius: 10,
              position: 'relative'
            }}
            key={file.uid}
          >
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                opacity: 0,
                zIndex: 100,
                transition: 'opacity 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = 1
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = 0
              }}
            >
              <div
                onClick={() => {
                  Modal.info({
                    title: '预览',
                    content: (
                      <img
                        src={url || file.url}
                        width="100%"
                        alt={file.name.split('.')[0]}
                      />
                    )
                  })
                }}
              >
                <IconEye style={{ fontSize: 12, color: '#fff' }} />
              </div>
              <div>
                <IconDelete
                  style={{ fontSize: 12, color: '#fff', marginLeft: 10 }}
                  onClick={() => {
                    props.onRemove(file)
                  }}
                />
              </div>
            </div>
            <img
              src={url}
              style={{ width: '100%', height: '100%', borderRadius: 10 }}
              alt={file.name.split('.')[0]}
            />
          </div>
        )
      })}
    </div>
  )

  // 动态列表操作方法
  const addScrollItem = useCallback(() => {
    if (helloData.length >= 5) {
      Message.error('最多只能添加5条滚动条内容')
      return
    }
    setHelloData([...helloData, ''])
    setValidationErrors({})
  }, [helloData])

  const removeScrollItem = useCallback(
    (index) => {
      // 只剩一条时不允许删除
      if (helloData.length <= 1) {
        Message.warning('至少保留一条滚动文本')
        return
      }
      const newList = [...helloData]
      newList.splice(index, 1)
      setHelloData(newList)
      const newErrors = { ...validationErrors }
      delete newErrors[index]
      setValidationErrors(newErrors)
    },
    [helloData, validationErrors]
  )

  const handleScrollChange = useCallback(
    (index, value) => {
      const newList = [...helloData]
      newList[index] = value
      setHelloData(newList)

      const newErrors = { ...validationErrors }
      if (!value.trim()) {
        newErrors[index] = `第${index + 1}项不能为空`
      } else {
        delete newErrors[index]
      }
      setValidationErrors(newErrors)
    },
    [helloData, validationErrors]
  )

  const getScrollListData = useCallback(() => {
    setHelloData(helloData.filter((item) => item.trim()))
    return helloData
  }, [helloData])

  const validateScrollList = useCallback(() => {
    const errors = {}
    let isValid = true

    // helloData?.forEach((item, index) => {
    //   if (!item.trim()) {
    //     errors[index] = `第${index + 1}项不能为空`
    //     isValid = false
    //   } else if (item.length > 50) {
    //     errors[index] = `第${index + 1}项不能超过50个字符`
    //     isValid = false
    //   }
    // })

    setValidationErrors(errors)
    return isValid
  }, [helloData])

  const beforeUpload = (file) => {
    var AllImgExt = '.png|.jpg|.jpeg|.gif|.svg|'
    var extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase() //（把路径中的所有字母全部转换为小写）
    if (AllImgExt.indexOf(extName + '|') === -1) {
      let ErrMsg =
        '该文件类型不允许上传。请上传 .png,.jpg,.jpeg,.gif,.svg类型的文件，当前文件类型为' +
        extName
      Message.error(ErrMsg)
      return false
    }
    const isLt10M = !(
      b2ValueUnit(file.size)[1] === 'B' ||
      b2ValueUnit(file.size)[1] === 'KB' ||
      (b2ValueUnit(file.size)[1] === 'MB' && b2ValueUnit(file.size)[0] <= 5)
    )
    return new Promise((resolve, reject) => {
      if (isLt10M) {
        Message.error('上传文件不能大于5MB')
        reject()
      } else {
        resolve()
      }
    })
  }
  const setRadioValue = (value) => {
    console.log('setRadioValue', value)
    setShowLogo(value)
  }
  const handleSubmit = useCallback(
    (defaultData) => {
      if (validateScrollList()) {
        // 收集所有组件信息
        const formData = {
          setting: {
            ...setting,
            hellodata: getScrollListData(),
            GlobalConfiguration: {
              ...setting.GlobalConfiguration,
              business_logo: homeColorLogo,
              white_logo: whiteLogo,
              home_banner: homeBackgroundIcon,
              showlogo: showLogo, // 从Radio组件获取的值
              home_uptitle: homeTextLine1,
              home_title: homeTextLine2,
              css: colorConfig.reduce((obj, item) => {
                obj[item.label] = item.value
                return obj
              }, {})
            }
          },
          app_id: data?.project_app?.app_id || ''
        }
        if (defaultData) {
          formData.setting = defaultData
          window.location.reload()
        }
        updateSaasSetting(formData).then((res) => {
          if (res.code === 200) {
            Message.success('更新成功')
            setTimeout(() => {
              // 向 iframe 子页面发送刷新指令
              const iframe = document.querySelector('iframe')
              if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage({ type: 'refresh' }, '*')
              }
            }, 800)
          } else {
            Message.error(res.msg || '更新失败')
          }
        })
      }
    },
    [
      validateScrollList,
      homeColorLogo,
      whiteLogo,
      homeBackgroundIcon,
      homeTextLine1,
      homeTextLine2,
      colorConfig,
      showLogo,
      setting,
      getScrollListData,
      data
    ]
  )

  return (
    <div className="sass-setting-set">
      {/* <div className="sass-setting-info-title">风格配置</div> */}

      {/* 上传区域 */}
      <div className="style-setting-title" style={{ marginTop: 0 }}>
        首页彩色logo
        <div className="style-setting-title-desc-small">
          （请上传svg格式，建议尺寸150px*50px）
        </div>
      </div>
      <Upload
        renderUploadList={renderUploadList2}
        accept={'.png,.jpg,.jpeg,.gif,.svg'}
        fileList={homeColorLogoFile ? [homeColorLogoFile] : []}
        limit={1}
        onChange={(fileList) => setHomeColorLogoFile(fileList[0])}
        customRequest={(option) => {
          handleUpload(option, setHomeColorLogo, setHomeColorLogoFile)
        }}
        beforeUpload={beforeUpload}
      >
        <div className="style-setting-upFile-box">
          <IconPlus style={{ fontSize: 20, color: '#A6A6A6' }} />
        </div>
      </Upload>

      <div className="style-setting-title">
        白色logo
        <div className="style-setting-title-desc-small">
          （请上传svg格式，建议尺寸200px*50px）
        </div>
      </div>
      <Upload
        renderUploadList={renderUploadList2}
        accept={'.png,.jpg,.jpeg,.gif,.svg'}
        fileList={whiteLogoFile ? [whiteLogoFile] : []}
        limit={1}
        onChange={(fileList) => setWhiteLogoFile(fileList[0])}
        customRequest={(option) => {
          handleUpload(option, setWhiteLogo, setWhiteLogoFile)
        }}
        className="up-icon"
        beforeUpload={beforeUpload}
      >
        <div className="style-setting-upFile-box">
          <IconPlus style={{ fontSize: 20, color: '#A6A6A6' }} />
        </div>
      </Upload>

      <div className="style-setting-title">是否联名展示logo</div>
      <Radio.Group
        className="style-setting-radio"
        value={showLogo}
        onChange={setRadioValue}
      >
        <Radio value={true}>是</Radio>
        <Radio value={false}>否</Radio>
      </Radio.Group>

      <div className="style-setting-title">首页背景icon</div>
      <div className="style-setting-title-desc">
        支持 JPG、JPEG、PNG、GIF、SVG 格式的图片，建议尺寸480px*480px
      </div>
      <Upload
        renderUploadList={renderUploadList1}
        accept={'.png,.jpg,.jpeg,.gif,.svg'}
        fileList={homeBackgroundIconFile ? [homeBackgroundIconFile] : []}
        limit={1}
        onChange={(fileList) => setHomeBackgroundIconFile(fileList[0])}
        customRequest={(option) => {
          handleUpload(option, setHomeBackgroundIcon, setHomeBackgroundIconFile)
        }}
        className="home-icon"
        beforeUpload={beforeUpload}
      >
        <div className="style-setting-upFile-icon">
          <IconPlus style={{ fontSize: 20, color: '#A6A6A6' }} />
        </div>
      </Upload>

      {/* 首页文本配置 */}
      <div className="style-setting-title">首页大文本</div>
      <Form>
        <Form.Item label="第一行">
          <Input
            className="custom-input-set"
            style={{ width: '100%' }}
            value={homeTextLine1}
            onChange={(e) => setHomeTextLine1(e.target?.value || e)}
            placeholder="请输入第一行文本"
          />
        </Form.Item>
        <Form.Item label="第二行" style={{ marginBottom: 0 }}>
          <Input
            className="custom-input-set"
            style={{ width: '100%' }}
            value={homeTextLine2}
            onChange={(e) => setHomeTextLine2(e.target?.value || e)}
            placeholder="请输入第二行文本"
          />
        </Form.Item>
      </Form>

      {/* 滚动文本配置 */}
      <div className="style-setting-title">对话框上方滚动文本</div>
      <div className="scroll-text-box">
        {helloData?.map((item, idx) => (
          <div key={idx} className="scroll-text-item">
            <Input
              className="custom-input-set"
              style={{ width: 320 }}
              value={item}
              onChange={(e) =>
                handleScrollChange(
                  idx,
                  typeof e === 'string' ? e : e.target?.value || e
                )
              }
              placeholder="请输入滚动文本"
            />
            <IconDelete
              style={{
                cursor: 'pointer',
                color: '#3f4bf5ff',
                width: 20,
                height: 20,
                marginLeft: 12
              }}
              onClick={() => removeScrollItem(idx)}
            />
            {validationErrors[idx] && (
              <span
                style={{
                  color: 'red',
                  fontSize: 12,
                  marginTop: 4,
                  display: 'block'
                }}
              >
                {validationErrors[idx]}
              </span>
            )}
          </div>
        ))}
        {helloData.length < 5 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-evenly',
              marginTop: 8
            }}
          >
            <Button
              onClick={addScrollItem}
              style={{
                marginTop: 8,
                borderRadius: 16,
                width: 320,
                border: '1px solid #d8e0f0'
              }}
            >
              <IconPlus style={{ fontSize: 16, color: '#A6A6A6' }} />
            </Button>
          </div>
        )}
      </div>

      {/* 主题颜色配置 - 遍历渲染 */}
      <div className="style-setting-title">主题颜色配置</div>
      <div className="color-settings-container">
        {colorConfig.map((config, index) => (
          <div key={index} className="scroll-text-item">
            {config.name}:
            <div>
              <div className="style-setting-color-box">
                <div
                  className="style-setting-color-box-item"
                  style={{ background: config.value }}
                ></div>
                <Popover
                  trigger="click"
                  content={
                    <div>
                      <ColorPicker
                        value={config.value}
                        onChange={config.onChange}
                      />
                    </div>
                  }
                >
                  <div className="style-setting-color-box-icon"></div>
                </Popover>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div
        className="confirm-default"
        onClick={() => handleSubmit(saasDefaultSetting)}
        style={{ margin: '16px 0' }}
      >
        恢复默认
      </div>
      <Button
        type="primary"
        className="confirm-recharge"
        onClick={() => handleSubmit()}
        style={{ margin: '16px 0' }}
      >
        确认
      </Button>
    </div>
  )
}

export default SaasSeting
